import { render, staticRenderFns } from "./RecommendBanner.vue?vue&type=template&id=293d68a7"
import script from "./RecommendBanner.vue?vue&type=script&lang=js"
export * from "./RecommendBanner.vue?vue&type=script&lang=js"
import style0 from "./RecommendBanner.vue?vue&type=style&index=0&id=293d68a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports